// Book effect
import 'atropos/css';
import Atropos from 'atropos';

const osuiAtropos = Atropos({
  el: '.shiny-book-atropos',
  // rest of parameters
});

function Book() {
  return(
    <div class="atropos shiny-book-atropos">
      <div class="atropos-scale">
        <div class="atropos-rotate">
          <div class="atropos-inner">
            <a 
              href="https://www.routledge.com/Outstanding-User-Interfaces-with-Shiny/Granjon/p/book/9780367643652">
                <img 
                  src="https://user-images.githubusercontent.com/18291543/181491295-1a5b498c-e7ee-428c-a1af-c3ee22e35ef5.jpg" 
                  width="140px" 
                  alt="Outstanding Shiny UI book cover"
                  height="200px">
                </img>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Book;